import request from '@/utils/request'


// 查询商品规格值模版列表
export function listSpecValue(query) {
  return request({
    url: '/spec/specValue/list',
    method: 'get',
    params: query
  })
}

// 查询商品规格值模版分页
export function pageSpecValue(query) {
  return request({
    url: '/spec/specValue/page',
    method: 'get',
    params: query
  })
}

// 查询商品规格值模版详细
export function getSpecValue(data) {
  return request({
    url: '/spec/specValue/detail',
    method: 'get',
    params: data
  })
}

// 新增商品规格值模版
export function addSpecValue(data) {
  return request({
    url: '/spec/specValue/add',
    method: 'post',
    data: data
  })
}

// 修改商品规格值模版
export function updateSpecValue(data) {
  return request({
    url: '/spec/specValue/edit',
    method: 'post',
    data: data
  })
}

// 删除商品规格值模版
export function delSpecValue(data) {
  return request({
    url: '/spec/specValue/delete',
    method: 'post',
    data: data
  })
}
